<template>
    <div class="container">
        <div class="title">{{ title }}</div>
        <div class="table">
            <div class="background-color-eee row-same-style">
                <div class="left-part">成色</div>
                <div class="right-part">
                    <div class="min">
                        <span>最低</span>
                        <span>平台回收价</span>
                    </div>
                    <span>至</span>
                    <div class="max">
                        <span>最高</span>
                        <span>平台回收价</span>
                    </div>
                </div>
            </div>
            <div class="table-cell row-same-style" :class="caclBackGroundColor(index)"
                v-for="(item, index) in sortPrice" :key="item.id">
                <div class="left-part">{{ item.newsName }}</div>
                <div class="right-part">
                    <div class="min">
                        ￥{{ item.minPrice && item.minPrice / 100 }}
                    </div>
                    <span>~</span>
                    <div class="max">
                        ￥{{ item.price && item.price / 100 }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stateProps: {
            default: () => {
                return []
            }
        },
        title: {
            default: () => {
                return '价格分析'
            }
        }
    },
    computed: {
        // 成色降序排序
        sortPrice() {
            return this.stateProps.sort((a, b) => a.newsId - b.newsId)
        }
    },
    methods: {
        caclBackGroundColor(index) {
            if ((index + 1) % 2 === 0) {
                return 'background-color-eee'
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.container {
    width: 702px;
    margin: 24px auto 0;

    &>.title {
        font-size: 28px;
        line-height: 40px;
        color: #1d1d1d;
        margin-bottom: 24px;
        font-weight: bold;
    }

    &>.table {
        border: 1px solid #F7F7F7;
        display: flex;
        flex-direction: column;

        .left-part {
            width: 50%;
            font-size: 28px;
            font-weight: 600;
            color: #1D1D1D;
        }

        .right-part {
            width: 50%;
            font-size: 22px;
            font-weight: 400;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>.min,
            &>.max {
                font-size: 22px;
                display: flex;
                flex-direction: column;
                align-items: center;

                &>span {
                    display: inline-block;
                }

                &>span:last-of-type {
                    font-size: 18px;
                    color: #999999;
                }
            }

            &>span {
                display: block;
            }
        }

        .table-cell .min,
        .table-cell .max {
            display: flex;
            justify-content: center;
            font-size: 22px;
            color: #1D1D1D;
            font-weight: 400;
            min-width: 90px;
        }

        &>div {
            width: 100%;
            height: 80px;
            padding: 0 32px;
        }

        &>.row-same-style {
            display: flex;
            align-items: center;
        }

        .background-color-eee {
            background: rgb(247, 247, 247)
        }
    }
}
</style>
